export const constEmptyData = "Данных не найдено";
